<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>รวมโครงการ{{ location }}</span>
							</div>
							<div class="search-filter">
								<h1>รวมโครงการ</h1>

								<div class="pl-3 pr-5">
									<h2>{{ location }}</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container>
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="py-4">
							<h1 class="red--text">
								รวมโครงการบ้านนนทบุรี ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด
							</h1>
							<p class="mt-4">
								ใครที่กำลังมองหาทำเลที่อยู่อาศัยใกล้กรุงเทพอย่างโครงการบ้านนนทบุรี ที่ได้รับอิทธิพลความเจริญไปไม่น้อยจากเขตต่างๆ ของกรุงเทพฯ ทำให้การเดินทางภายในพื้นที่สะดวกสบายไม่ต่างจากกรุงเทพแม้แต่น้อย ทั้งยังมีแหล่งที่พักอาศัยอย่างบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม คอนโดให้เลือกสรร โดยมีราคาที่เอื้อมถึงคือเฉลี่ย 4-7 ล้านบาท และหากเป็นทาวน์เฮ้าส์จะมีราคาอยู่ที่ล้านต้นๆ ไปจนถึงราคา 3 ล้านบาท
							</p>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="category-menu mx-auto px-4 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'singlehome'}}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'townhome'}}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'condo'}}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'shophouse'}}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="property-recommend justify-center"
					no-gutters
				>
					<v-col xl="8">
						<h2 class="text-center my-7">
							แนะนำโครงการ<span class="red--text">{{ location }}</span>
						</h2>

						<propertyCarousel
							white
							style="margin-bottom: 60px;"
							:query="{ province }"
						/>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'singlehome' } }">
								โครงการบ้านเดี่ยว<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'HOME', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'singlehome' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'singlehome' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'townhome' } }">
								โครงการทาวน์โฮม<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'TOWNHOUSE', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'townhome' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'townhome' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'condo' } }">
								โครงการคอนโด<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'CONDO', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'condo' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'condo' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'shophouse' } }">
								โครงการอาคารพาณิชย์<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'COMMERCIAL_BUILDING', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'shophouse' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'shophouse' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<h2 class="red--text">
							<img
								src="/images/2.0/icon/price-tag-bk.png"
								height="25"
								class="mr-2"
							>
							รวมราคาโครงการบ้านนนทบุรี
						</h2>
						<v-card
							class="pa-4 mt-4 mx-md-0 area-content"
							flat
							tile
						>
							<p class="mt-2 mb-0">
								<b>ไทรน้อย</b> เป็นย่านที่มีพื้นที่มากที่สุดในจังหวัดนนทบุรี แต่ส่วนใหญ่จะเป็นพื้นที่เกษตรกรรม จึงมีโครงการบ้านนนทบุรีอยู่ในพื้นที่ไม่มากนัก ไทรน้อยยังแบ่งออกเป็น 7 เขตพื้นที่ได้แก่ ไทรน้อย ราษฎร์นิยม หนองเพรางาย ไทรใหญ่ ขุนศรี คลองขวางและทวีวัฒนา ด้วยความที่มีอาณาเขตติดกับนครปฐมและปทุมธานีทำให้พื้นที่นี้ยังคงเงียบสงบ และยังคงใช้การเดินทางด้วยรถยนต์เป็นหลัก โครงการบ้านในพื้นที่จึงมีราคาที่เอื้อมถึงได้ไม่ยากโดยเริ่มต้นที่ 1 ล้านบาทขึ้นไป
							</p>
							<p class="mt-2 mb-0">
								<b>บางบัวทอง</b> เป็นย่านที่มีโครงการบ้านค่อนข้างมาก จึงเรียกได้ว่า เป็นพื้นที่สำหรับที่อยู่อาศัยแห่งหนึ่งในนนทบุรี บางบัวทองประกอบด้วยโครงการบ้านเดี่ยวเป็นส่วนใหญ่ โดยในพื้นที่มักเป็นโครงการบ้านขนาดใหญ่ที่มีราคาสูงหรือโครงการบ้านหรู ดังนั้นราคาบ้านเดี่ยว บ้านมือสองในพื้นที่บางบัวทองจึงค่อนข้างสูงกว่าพื้นที่อื่นโดยจะเริ่มต้นที่ 7 ล้านบาทขึ้นไป โดยมีสาเหตุมาจากการเดินทางที่สามารถเข้าเมืองได้ง่ายและยังสามารถใช้รถไฟฟ้า MRT สายสีม่วงสถานีเตาปูนในการเดินทางเข้าเมืองไปพื้นที่อื่นได้ด้วย
							</p>

							<v-expansion-panels flat>
								<v-expansion-panel>
									<v-expansion-panel-header>
										<span>อ่านเพิ่มเติม</span>
										<template v-slot:actions>
											<v-icon color="rgb(237,28,36)">
												$expand
											</v-icon>
										</template>
									</v-expansion-panel-header>
									<v-expansion-panel-content eager>
										<p class="mt-2 mb-0">
											<b>บางใหญ่</b> เป็นย่านที่ค่อนข้างคึกคัก เรียกได้ว่า เป็นย่านสำหรับโครงการบ้านนนทบุรีอย่างแท้จริง เพราะเป็นพื้นที่รองรับการขยายตัวจากกรุงเทพฯ ทำให้การเดินทางด้วยรถยนต์ค่อนข้างเข้า-ออกเมืองได้อย่างสะดวกสบาย โดยในย่านบางใหญ่นี้จะประกอบไปด้วย บางม่วง บางแม่นาง บางเลน เสาธงหิน บางใหญ่และบ้านใหม่ ในแต่ละพื้นที่ก็จะได้รับความนิยมต่างกันออกไปทำให้ราคาบ้านเดี่ยว บ้านมือสอง ทาวน์โฮม เหล่านี้มีความเปลี่ยนแปลงตามไปด้วย โดยจะมีราคาเริ่มต้นอยู่ที่ 1-7 ล้านบาท
										</p>
										<p class="mt-2 mb-0">
											<b>บางกรวย</b> เป็นพื้นที่ที่ติดกับกรุงเทพฯ จึงมีโครงการบ้านนนทบุรีค่อนข้างมากและยังได้รับการพัฒนาเนื่องจากการขยายตัวมาจากกรุงเทพจึงสามารถเดินทางเข้าเมืองได้สะดวก เหมาะสำหรับคนที่ต้องการมีบ้านในราคาไม่สูงเท่าฯ โดยทำเลบางกรวยนี้ยังแบ่งออกเป็น 9 ตำบลได้แก่ วัดชลอ บางกรวย คูเวียง บางสีทอง บางขนุน บางขุนกอง บางคูเวียง มหาสวัสดิ์ ปลายบางและศาลากลาง และโครงการบ้านนนทบุรีในบางกรวยนี้จะเริ่มต้นอยู่ที่ 2-10 ล้านบาท ขึ้นอยู่กับทำเลที่ตั้งและขนาดของบ้าน
										</p>
										<p class="mt-2 mb-0">
											<b>เมืองนนทบุรี</b> เป็นทำเลได้รับการพัฒนาจากการขยายตัวจากกรุงเทพอย่างเต็มขั้น มีทั้งอาคารสำนักงาน มหาวิทยาลัยและย่านการค้ามากมาย ทำให้เป็นพื้นที่คึกคักมากที่สุดในนนทบุรีเลยก็ว่า เพราะการเดินทางสำหรับเมืองนนทบุรีนั้นมีรถไฟฟ้าสายสีม่วงวิ่งผ่านอยู่หลายสถานี  โดยเมืองนนทบุรีนี้จะแบ่งออกเป็น 10 ตำบล ได้แก่ สวนใหญ่ ตลาดขวัญ บางเขน บางกระสอ ท่าทราย บางไผ่ บางศรีเมือง บางกร่าง ไทรม้าและบางรักน้อย และในส่วนของราคาบ้านเดี่ยว บ้านมือสองจะมีราคาเริ่มต้น 4 ล้านบาทขึ้นไป คอนโดมิเนียมจะเริ่มต้นที่ 1 ล้านบาทซึ่งเป็นราคาที่เอื้อมถึงได้ไม่ยาก
										</p>
										<p class="mt-2">
											<b>ปากเกร็ด</b> เป็นอำเภอหนึ่งที่มีความแตกต่างในการพัฒนาพื้นที่ค่อนข้างมาก เพราะมีแม่น้ำเจ้าพระยาตัดผ่านทำให้พื้นที่ฝั่งหนึ่งเป็นพื้นที่ของสวนผลไม้ ไร่นา ส่วนอีกฝั่งหนึ่งจะได้รับการพัฒนาเป็นแหล่งที่พักอาศัย โครงการบ้านนนทบุรี ห้างสรรพสินค้า โรงงานและยังเป็นที่ตั้งของหน่วยงานราชการมากมาย ทำให้มีดีมานด์ในการอยู่อาศัยพอสมควร คอนโดในพื้นที่ปากเกร็ดจะมีราคาเริ่มต้นอยู่ที่ 1 ล้านบาทต้นๆ ขณะที่บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม ทาวน์เฮ้าส์จะเริ่มต้นที่ 2-3 ล้านบาทขึ้นไป พื้นที่ในปากเกร็ดจะแบ่งเป็น 12 ตำบลได้แก่ ปากเกร็ด บางตลาด บ้านใหม่ บางพูด บางตะไนต์ คลองพระอุดม ท่าอิฐ เกาะเกร็ด อ้อมเกร็ด คลองข่อย บางพลับและคลองเกลือ
										</p>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-card>

						<h2 class="red--text mt-8">
							<img
								src="/images/2.0/icon/idea-bk.png"
								height="25"
								class="mr-2"
							>
							วิธีการเลือกโครงการในจังหวัดนนทบุรี
						</h2>
						<v-card
							class="pa-4 mt-4 mx-md-0 area-content"
							flat
							tile
						>
							<h3 class="mt-3">
								ทำเลที่อยู่อาศัยในโซนจังหวัดนนทบุรี
							</h3>
							<p class="mt-2 mb-0">
								<b>ไทรน้อย</b> เป็นพื้นที่เงียบสงบเพราะพื้นที่สวนใหญ่เป็นพื้นที่เกษตรกรรม ทำให้เหมาะกับคนที่ต้องการพักผ่อนในทำเลเดินทางสะดวกและใกล้ชิดกับธรรมชาติ เพราะสถานที่ท่องเที่ยวในพื้นที่ส่วนใหญ่เป็นแหล่งท่องเที่ยวผสมผสานกับ เช่น ตลาดน้ำไทรน้อย ฟาร์มเห็ดอย่างกระท่อมเห็ด หรือจะเป็นคาเฟ่ริมทะเลสาบก็มีให้เลือกท่องเที่ยวด้วยเช่นกัน และด้วยพื้นที่กว้างใหญ่นี้จึงเหมาะกับการใช้รถยนต์ส่วนตัวเท่านั้น
							</p>

							<v-expansion-panels flat>
								<v-expansion-panel>
									<v-expansion-panel-header>
										<span>อ่านเพิ่มเติม</span>
										<template v-slot:actions>
											<v-icon color="rgb(237,28,36)">
												$expand
											</v-icon>
										</template>
									</v-expansion-panel-header>
									<v-expansion-panel-content eager>
										<p class="mt-2 mb-0">
											<b>บางบัวทอง</b> จะขยับเข้ามาสู่เขตพื้นที่อยู่อาศัยมากขึ้น โดยในพื้นที่จะมีโครงการบ้านนนทบุรีมากมายให้เลือก จึงมีบรรยากาศและสิ่งอำนวยความสะดวกที่เหมาะแก่การใช้ชีวิตประจำวันมากกว่า เช่น มีร้านอาหาร ตลาด และห้างสรรพสินค้ามากขึ้น เป็นทำเลที่เชื่อมไปยังแหล่งท่องเที่ยวธรรมชาติพร้อมกับแหล่งไลฟ์สไตล์ ศูนย์การค้าและอาคารสำนักงานหรือศูนย์ราชการได้ไม่ยาก
										</p>
										<p class="mt-2 mb-0">
											<b>บางใหญ่</b> เป็นอีกหนึ่งทำเลที่มีโครงการบ้านเป็นจำนวนมาก ทั้งบ้านเดี่ยว บ้านมือสองเพราะเป็นพื้นที่รองรับการอยู่อาศัยจากการขยายตัวของกรุงเทพและเมืองนนทบุรี จึงเป็นอีกหนึ่งย่านที่มีสิ่งอำนวยความสะดวกครบครัน และเต็มไปด้วยบรรยากาศการใช้ชีวิต มีถนนหนทางที่ค่อนข้างสะดวก เดินทางเข้า-ออกเมืองได้ง่าย เหมาะกับคนที่ต้องการเดินทางได้ง่ายมักจะเลือกอยู่ในโซนที่ใกล้กับเมืองนนทบุรี เพราะหากเป็นแถบที่อยู่ติดกับนครปฐมมักเป็นพื้นที่เกษตรกรรม ดังนั้น ใครที่ชอบธรรมชาติแต่ยังต้องการเข้ากรุงเทพได้ง่ายสามารถเลือกที่นี่ได้
										</p>
										<p class="mt-2 mb-0">
											<b>บางกรวย</b> เป็นทำเลติดกับกรุงเทพฯ จึงมีความสะดวกสบายหลายอย่างที่คล้ายกัน ไม่ว่าจะเป็นร้านอาหาร การเดินทางและการใช้ชีวิตที่สะดวกสบาย ทำให้เป็นพื้นที่หนึ่งที่หลายคนมาเลือกซื้อโครงการบ้านนนทบุรีกันที่นี่ เพราะสามารถใช้เวลาเพียงไม่นานก็เดินทางเข้ากรุงเทพได้ง่าย และยังมีสิ่งอำนวยความสะดวกอย่างเช่น ห้างสรรพสินค้า ศูนย์การค้า โรงเรียนและโรงพยาบาลครบครันทีเดียว
										</p>
										<p class="mt-2 mb-0">
											<b>เมืองนนทบุรี</b> เป็นทำเลที่คึกคักมากที่สุดในนนทบุรีก็ว่าได้ ใครที่ต้องการใช้รถสาธารณะในการเดินทางมักจะเลือกที่นี่เพราะมีรถไฟฟ้าสายสีม่วง และยังเหมาะกับคนทำงานเพราะเมืองนนทบุรี ที่มีแหล่งอาคารสำนักงานและศูนย์ราชการตั้งอยู่ด้วย สำหรับสถานที่ท่องเที่ยงในพื้นที่นี้มักเป็นแหล่งไลฟ์สไตล์ทันสมัยอย่างห้างสรรพสินค้า ศูนย์การค้า จึงมีผู้คนค่อนข้างพลุกพล่านทีเดียว
										</p>
										<p class="mt-2">
											<b>ปากเกร็ด</b> เป็นพื้นที่ค่อนข้างหลากหลายที่สามารถเลือกได้ทั้งฝั่งเมืองที่มีสิ่งอำนวยความสะดวกครบครัน และฝั่งใกล้ชิดธรรมชาติที่มีแหล่งท่องเที่ยวอย่างเกาะเกร็ด จึงเหมาะกับคนที่ต้องการการเดินทางที่สะดวกสบายในงบประมาณที่เอื้อมถึงและยังสามารถใช้วันหยุดใกล้ชิดกับธรรมชาติพื้นที่สีเขียวไปพร้อมกันได้ โดยใครที่เลือกอยู่ในพื้นที่นี้จะใช้รถยนต์ส่วนตัวในการเดินทางเป็นหลัก
										</p>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'projects'

import { mapGetters } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyCarousel from '~/components/2.0/property-carousel'

export default {
	// scrollToTop: true,
	name: 'NonthaburiHub',
	layout: 'default_2',

	components: {
		searchForm,
		propertyCarousel,
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let path = context.route.path.split('/')
		if (path[path.length - 1] === '') {
			path.splice(path.length - 1, 1)
		}
		let content = path[1]

		data['title'] = 'รวมโครงการบ้านนนทบุรี ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด'
		data['description'] = 'โครงการบ้านนนทบุรี ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง หมู่บ้านจัดสรร ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด บางใหญ่ บางบัวทอง ปากเกร็ด บางกรวย รัตนาธิเบศร์'

		await context.store.dispatch('page/initial', data)

		return { path, content }
	},

	data:() => ({
		location: 'นนทบุรี',
		locationName: 'nonthaburi',
		province: 3,
		keepAliveActivated: false,
		loading: false,
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
		}),

		market_selected () {
			if (this.content === 'townhome') {
				return 'TOWNHOUSE'
			} else if (this.content === 'condo') {
				return 'CONDO'
			} else if (this.content === 'shophouse') {
				return 'COMMERCIAL_BUILDING'
			}

			return 'HOME'
		},

		bannerImg () {
			return '/images/2.0/all-project-banner.jpg'
		},
	},

	watch: {

	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			// this.search()
		}
	},

	created() {

	},

	mounted() {

	},

	methods: {

	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.property-recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%, rgba(157,30,37,1) 60%, rgba(237,28,36,1) 60%, rgba(237,28,36,1) 100%);
		position: absolute;
		width: 9%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
h2.property-sample {
	a {
		text-decoration: none;
		color: rgba(0, 0, 0, 0.87);
	}
}
.area:hover {
	background-color: #3a3a3a;
	color: #fff;
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
